import { connect } from 'react-redux';
import { AnyAction, Dispatch } from 'redux';
import { State } from '../../../types/mx/reducers';
import * as ModalActions from '../../../../common/actions/ModalActions';
import MissingLoanRequiredFieldsView from '../components/views/MissingLoanRequiredFieldsView';
import { EMPTY_CATALOG } from '../../../constants/GlobalConstants';

const mapStateToProps = (state: State, ownProps) => {
    const previewSubMenuErrors = ownProps.data ? ownProps.data.requiredFields : [];
    const target = ownProps.data ? ownProps.data.target || EMPTY_CATALOG : EMPTY_CATALOG;
    return {
        previewSubMenuErrors,
        target
    };
};

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
    return {
        onClose: () => {
            dispatch(ModalActions.CLOSE_MODAL_ACTION.action());
        }
    };
};

const MissingLoanRequiredFieldsContainer = connect(
    mapStateToProps, mapDispatchToProps
)(MissingLoanRequiredFieldsView);

export default MissingLoanRequiredFieldsContainer;